import React from 'react';
import Slider from '@mui/material/Slider';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * SliderComponent is a reusable component that renders a responsive slider.
 * @param {number} value - The value/label of the slider.
 * @param {number} min - The minimum value of the slider.
 * @param {number} max - The maximum value of the slider.
 * @param {number} step - The step value to increase/decrease the value by.
 * @param {function} onChange - The function that handles the change state of the slider.
 * @param {array} marks - The marks of the slider.
 * @param {string} location - The location i.e. on which page of the slider.
 * @param {string} className - The class name of the slider.
 * @param {string} dataCy - The data-cy attribute for the cypress scripts.
 **/

const SliderComponent = ({ value, min, max, step, onChange, marks, location,disabled }) => {
  return (
    <Box className="slider-component" width="100%" px={2}>
      <Slider
        className="slider-input"
        value={value}
        min={min}
        max={max}
        step={step}
        marks={marks}
        onChange={onChange}
        disabled={disabled}
      />
      <Box display="flex" justifyContent="space-between" mt={1}>
        <Typography variant="caption" align="left" style={{ fontSize: '1rem' }}>
          {min}
        </Typography>
        <Typography variant="caption" align="right" style={{ fontSize: '1rem' }}>
          {max}
        </Typography>
      </Box>
    </Box>
  );
};

export default SliderComponent;
